import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import ArticlePage from "@/pages/article/page";
import ArticleNikePage from "@/pages/article-nike/page";
import ArticleJordanPage from "@/pages/article-jordan/page";
import ArticleWysylkaPage from "@/pages/article-wysylka/page";
import ArticlePorownaniePage from "@/pages/article-porownanie/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/artykul/kakobuy-spreadsheet-poradnik-2026",
    element: <ArticlePage />,
  },
  {
    path: "/artykul/nike-kakobuy-spreadsheet-2026",
    element: <ArticleNikePage />,
  },
  {
    path: "/artykul/jordan-kakobuy-spreadsheet-2026",
    element: <ArticleJordanPage />,
  },
  {
    path: "/artykul/wysylka-kakobuy-spreadsheet-polska",
    element: <ArticleWysylkaPage />,
  },
  {
    path: "/artykul/kakobuy-spreadsheet-vs-inne-porownanie",
    element: <ArticlePorownaniePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;